exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3B4mBM-_HstOFa ._3QWSfkWetuyFT2{width:0;height:18px;opacity:0;transition-duration:.15s;transition-property:opacity,width,margin}._3B4mBM-_HstOFa:hover ._3QWSfkWetuyFT2{opacity:.75;width:18px;margin-right:6px}", ""]);

// exports
exports.locals = {
	"externalLink": "_3B4mBM-_HstOFa",
	"externalIcon": "_3QWSfkWetuyFT2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2772/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/navigation.less
// module id = ySXr
// module chunks = 13